import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function projectReducer(state = initialState.project, action) {
	switch (action.type) {
		case types.PROJECT_LOADED: {
			return Object.assign({}, state,
				{
					id: action.body.item ? action.body.item.dossierId : null,
					item: action.body.item,
					errors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors,
					isLoaded: true,
					isSaved: action.body.isSaved
				});
		}

		case types.PROJECT_SAVED: {
			return Object.assign({}, state,
				{
					id: action.body.item.dossierId,
					item: action.body.item,
					errors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors
				});
		}

		case types.INFRASTRUCTUUR_VALIDATED: {
			return Object.assign({}, state,
				{
					infrastructuurErrors: action.body.errors,
					hasValidationErrors: action.body.hasValidationErrors
				});
		}

		case types.INFRASTRUCTUREN_LOADED: {
			const inEditMode = action.body.inEditMode;
			const sportinfrastructurenInDeBuurt = action.body.item.infrastructuren.filter(i => i.tienMinutenWandelen);
			const spakkiIdsVanSportinfrastructurenInDeBuurt = state.item.sportinfrastructurenInDeBuurt.filter(s => s.spakki != null).map(s => s.spakki.id);

			const nieuweSportinfrastructurenInDeBuurt = sportinfrastructurenInDeBuurt.filter(s => s.spakki != null && !spakkiIdsVanSportinfrastructurenInDeBuurt.includes(s.spakki.id));

			// lijst van reeds opgeslagen infrastructuren en nieuwe infrastructuren in de buurt
			let sportinfrastructurenInDeBuurtReedsInProject = state.item.sportinfrastructurenInDeBuurt.concat(nieuweSportinfrastructurenInDeBuurt);
			let sportinfrastructurenOpKaartReedsInProject = [];
			if (inEditMode == "false" || inEditMode === false) {
				let sportInfraNotNee = state.item.sportinfrastructurenInDeBuurt.filter(i => i.deelVanAanvraag === 2 || i.deelVanAanvraag == "2" || i.deelVanAanvraag === 0 || i.deelVanAanvraag == "0");
				let spakkiIdVanSportInfraNotNee = sportInfraNotNee.filter(s => s.spakki != null).map(s => s.spakki.id);
				sportinfrastructurenOpKaartReedsInProject = sportInfraNotNee.concat(sportinfrastructurenInDeBuurt.filter(s => s.spakki == null || !spakkiIdVanSportInfraNotNee.includes(s.spakki.id)));
			}
			else {
				sportinfrastructurenOpKaartReedsInProject = sportinfrastructurenInDeBuurtReedsInProject;
			}


			let item = action.body.project === null ? state.item : action.body.project;

			if (item.verdwijnenErInfrastructurenNietInSpakki &&
				item.sportinfrastructurenInDeBuurt.filter(x => !!x.spakki).length <= 0 &&
				sportinfrastructurenInDeBuurt.length > 0) {
				item.verdwijnenErInfrastructurenNietInSpakki = false;
			}

			return Object.assign({}, state,
				{
					item: Object.assign({}, item,
						{ sportinfrastructurenOpKaart: sportinfrastructurenOpKaartReedsInProject },
						{ sportinfrastructurenInDeBuurt: sportinfrastructurenInDeBuurtReedsInProject },
						{ straatHuisnummer: action.body.straat },
						{ gemeente: action.body.gemeente },
						{ postcode: action.body.postcode })
				});
		}

		case types.INFRASTRUCTUUR_SAVED: {
			let stateToUpdate = mergeDeep({}, state);
			let items = stateToUpdate.item.sportinfrastructurenInDeBuurt;
			let newItems = [...items.filter(x => x.id != action.body.item.id), action.body.item];

			stateToUpdate.isSaved = action.body.isReset && stateToUpdate.isSaved;

			stateToUpdate.item.sportinfrastructurenInDeBuurt = newItems.filter(i => i.tienMinutenWandelen);
			stateToUpdate.item.sportinfrastructurenOpKaart = newItems;

			return stateToUpdate;
		}

		case types.PROJECT_UNLOADED: {
			let stateToUpdate = mergeDeep({}, state);
			stateToUpdate.isLoaded = false;
			return stateToUpdate;
		}

		case types.INFRASTRUCTUUR_REMOVED: {
			let stateToUpdate = mergeDeep({}, state);
			let items = stateToUpdate.item.sportinfrastructurenInDeBuurt;
			let newItems = [...items.filter(x => x.id != action.body.item)];

			stateToUpdate.item.sportinfrastructurenInDeBuurt = newItems;
			stateToUpdate.item.sportinfrastructurenOpKaart = newItems;
			return stateToUpdate;
		}

		default:
			return state;
	}
}
